
import {Component, Mixins, Prop, Vue, Watch} from "vue-property-decorator";
import DosyaEsasNumarasi from "@/components/inputs/DosyaEsasNumarasi.vue";
import TelefonNumarasi from "@/components/inputs/TelefonNumarasi.vue";
import TakipDurumuPicker from "@/components/pickers/TakipDurumuPicker.vue";
import IcraDairesiPicker from "@/components/pickers/IcraDairesiPicker.vue";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import KararNumarasi from "@/components/inputs/KararNumarasi.vue";
import TakipTipiPicker from "@/components/pickers/TakipTipiPicker.vue";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import TakipEtiketiPicker from "@/components/pickers/TakipEtiketiPicker.vue";

@Component({
  components: {
    TakipEtiketiPicker,
    TakipTipiPicker,
    KararNumarasi,
    TcKimlikNumarasi,
    VergiNumarasi,
    IcraDairesiPicker,
    TakipDurumuPicker,
    TelefonNumarasi,
    DosyaEsasNumarasi
  }
})
export default class TakipListFilterForm extends Mixins(SimpleInputMixin) {
  @Prop({default: false}) loading!: boolean;

  openPanels: number[] = [];
  searchRequested = false;
  enterFromOpenPicker = false;
  // Tanımlı takip ek-alan türleri (dinamik filtre alanları için)
  ekAlanTurleri: Array<{ id: number; kod: string; isim: string }> = [];

  filters: any = {
    borcluAdSoyad: null,
    borcluTcKimlik: null,
    alacakliTcKimlik: null,
    borcluVergiKimlik: null,
    alacakliVergiKimlik: null,
    icraDairesi: null,
    dosyaEsasNo: null,
    alacakliAdSoyad: null,
    takipDurumu: null,
    ilamEsasNo: null,
    ilamKararNo: null,
    kartNo: null,
    icraProKartNo: null,
    mtsEsasNo: null,
    tuketiciKodu: null,
    kurumDosyaNo: null,
    takipTipiNo: null,
    keyword: null,
    ekAlanlar: {}
  };

  mounted() {
    // localValue ek-alan objesi yoksa başlat (reaktif)
    if (this.localValue && !this.localValue.ekAlanlar) {
      Vue.set(this.localValue, 'ekAlanlar', {});
    }
    this.loadEkAlanTurleri();
  }

  loadEkAlanTurleri() {
    this.$http.get('/api/v1/takip-ek-alan-turu').then((response: any) => {
      this.ekAlanTurleri = (response.data || []).map((t: any) => ({
        id: t.id,
        kod: t.kod,
        isim: t.isim
      }));
    }).catch(() => {
      this.ekAlanTurleri = [];
    });
  }

  onEkAlanInput(kod: string, value: string) {
    if (!this.localValue.ekAlanlar) {
      Vue.set(this.localValue, 'ekAlanlar', {});
    }
    if (value === '' || value === null || value === undefined) {
      Vue.delete(this.localValue.ekAlanlar, kod);
    } else {
      Vue.set(this.localValue.ekAlanlar, kod, value);
    }
    this.input();
  }

  restrictInput(event: any) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Enter'];
    const isNumeric = /^[0-9]$/;

    if (allowedKeys.includes(event.key)) return;

    if (!isNumeric.test(event.key)) {
      event.preventDefault();
    }
  }

  togglePanel(index: number) {
    if (this.openPanels.includes(index)) {
      this.openPanels = this.openPanels.filter((panelIndex) => panelIndex !== index);
      return;
    }

    this.openPanels = [...this.openPanels, index];
  }

  captureFilterEnter(event: KeyboardEvent) {
    const target = event.target as HTMLElement | null;
    const select = target ? target.closest('.v-select') : null;
    this.enterFromOpenPicker = Boolean(select && select.classList.contains('v-select--is-menu-active'));

    if (select && !this.enterFromOpenPicker) {
      event.preventDefault();
      event.stopPropagation();
      this.submitSearch();
    }
  }

  handleFilterEnter(event: KeyboardEvent) {
    event.preventDefault();

    if (this.enterFromOpenPicker) {
      this.enterFromOpenPicker = false;
      return;
    }

    this.submitSearch();
  }

  submitSearch() {
    if (this.loading || this.searchRequested) return;

    this.searchRequested = true;
    this.$emit('search');
  }

  @Watch('loading')
  onLoadingChange(loading: boolean) {
    if (!loading) {
      this.searchRequested = false;
    }
  }

  sifirla() {
    if (this.loading || this.searchRequested) return;

    this.localValue = {...this.filters, ekAlanlar: {}};
    this.input();
    this.submitSearch();
  }
}
